import React from 'react'
// TODO move ui
// import { Message, Text } from '@brainstud/schiphol-vtc-ui'
import { leadingZero } from '@brainstud/react-helpers'

const NoTemplate = props => (
  <div>
    <div>No template found in content/chapters/{leadingZero(props.chapter.prefix)}/Intro.js</div>
  </div>
)

export default NoTemplate
